import FundClimateProjectsProcurementPng from '@public/images/procurement/enable-user-procurement-image.png'
import { FC } from 'react'

import { BlogPreview } from '@/components/blogSlices/BlogPreview'
import { ColumnWrapOrder } from '@/components/TwoColumnLayout'
import TwoColumnLayoutWithCustomImageRatio from '@/components/TwoColumnLayoutWithCustomImageRatio'

const EnableYourUsersProcurement: FC = () => (
    <TwoColumnLayoutWithCustomImageRatio
        columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
        imagePaddingBottom={'108.64%'}
        imageAlt={'transaction offset notifications'}
        image={FundClimateProjectsProcurementPng}
        title={`Enable your users to fund vetted climate projects`}
        snippet={
            <BlogPreview
                title={'A guide to getting started with carbon offsetting as a business'}
                url={'/blog/the-complete-guide-to-carbon-offsetting-and-removal-for-businesses'}
            />
        }
        description={
            <>
                Enhance your customer experience by embedding high quality climate contributions
                into your platform. Our experts rigorously vet climate projects against a six-point
                criteria to deliver measurable impact and peace of mind. Boost customer loyalty and
                lead in sustainable supply chains.
            </>
        }
    />
)

export default EnableYourUsersProcurement
